import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageLayout from "./components/PageLayout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Article1 from "./pages/Article1";
import Article2 from "./pages/Article2";
import Article3 from "./pages/Article3";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import "./styles/global.css";

function App() {
  const { i18n } = useTranslation();

  const changeLang = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageLayout changeLang={changeLang}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/article/softwood-market" element={<Article1 />} />
          <Route path="/article/superwood-invention" element={<Article2 />} />
          <Route path="/article/arkansas-timber-center" element={<Article3 />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </PageLayout>
    </BrowserRouter>
  );
}

export default App;
